var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full",class:{'overflow-y-auto' : _vm.scrollable},style:({'height' : _vm.height})},[(_vm.loading)?_c('div',{},_vm._l((_vm.loadingList),function(index){return _c('global-skeleton',{key:index,attrs:{"loadingType":_vm.loadingType}})}),1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }